import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Cell, Grid } from '@phishtool/ui';
import { useLocation } from 'react-router-dom';
import PortalButtons from './portal-buttons';
import AccessForm from './access-form';
import { Header } from './header';
const EnterpriseQuotePortal = () => {
    const [quotePortal, setQuotePortal] = useState(null);
    const location = useLocation();
    const match = location.pathname.match(/enterprise-quote-portal\/([^/]*)/);
    const token = (match === null || match === void 0 ? void 0 : match[1]) || '';
    return (_jsxs(_Fragment, { children: [_jsx(Header, { quotePortal: quotePortal }), _jsx(Grid, { children: _jsx(Cell, { children: quotePortal ? (_jsx(PortalButtons, { quotePortal: quotePortal })) : (_jsx(AccessForm, { token: token, setQuotePortal: setQuotePortal })) }) })] }));
};
export default EnterpriseQuotePortal;
